import { defineMessages } from 'react-intl-next';

export const i18n: {
    contributor: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    confluenceFilterContributorPlaceholder: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    confluenceFilterLabelSelected: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    confluenceFilterLabelUnselected: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	contributor: {
		id: 'quick-find.filters.names.contributor',
		defaultMessage: 'Contributor',
		description: 'Label for filtering by contributor',
	},
	confluenceFilterContributorPlaceholder: {
		id: 'quick-find.confluence.filter.contributor.placeholder',
		defaultMessage: 'Find people',
		description: 'Placeholder for contributor filter search input',
	},
	confluenceFilterLabelSelected: {
		id: 'quick-find.confluence.filter.label.selected',
		defaultMessage: 'Selected',
		description: 'Confluence filter label selected',
	},
	confluenceFilterLabelUnselected: {
		id: 'quick-find.confluence.filter.label.unselected',
		defaultMessage: 'Suggested',
		description: 'Confluence filter label unselected',
	},
});
